import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#EAE8E8",
    },
    text: {
      primary: "#000",
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    allVariants: {
      fontWeight: 300,
    },
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiTableContainer: {
      defaultProps: {
        tabIndex: 0,
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => ({
          fontWeight: 600,
          paddingTop: "18px",
          fontSize: "1.0rem",
          [theme.breakpoints.down("sm")]: {
            fontSize: "0.925rem",
          },
          hyphens: "manual"
        }),
        body: ({ theme }) => ({
          fontWeight: 400,
          paddingTop: "18px",
          fontSize: "1.0rem",
          [theme.breakpoints.down("sm")]: {
            fontSize: "0.925rem",
          },
          hyphens: "auto"
        }),
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          fontWeight: 400,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
          root: {
            fontWeight: 400,
            "& > svg": {
            display: "inline-block",
            transform: "translateY(1px)",
          },
          },
        },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          "& > label": {
            display: "inline-block",
            hyphens: "manual",
            fontWeight: 500,
          },
          "&.Mui-selected > label": {
            fontWeight: 600,
          }
        },
      },
    },
    
    MuiButton: {
      styleOverrides: {
        root: {
            fontWeight: 400,
          "& > label": {
            display: "inline-block",
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        button: {
          fontWeight: 400,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "1.08rem",
          fontWeight: 400,
          color: "#333",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h4: {
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
